import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GalaxyNavControlService {
  readonly isOpen = signal(true);
  readonly navIsClosedForThisPage = signal(false);
  readonly isCollapsed = signal(false);

  toggle(): void {
    this.isOpen.update((isOpen) => !isOpen);
  }

  open(): void {
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }

  closeForThisPage(): void {
    this.close();
    this.navIsClosedForThisPage.set(true);
  }

  undoCloseForThisPage(): void {
    this.open();
    this.navIsClosedForThisPage.set(false);
  }

  toggleCollapse(): void {
    this.isCollapsed.update((collapsed) => !collapsed);
  }

  collapse(): void {
    this.isCollapsed.set(true);
  }

  expand(): void {
    this.isCollapsed.set(false);
  }
}
